/* tslint:disable:max-line-length */
import { PageBillingType } from '@mm/state/interfaces/connected-page';
import { OldToNewRolesMap } from '@mm/state/model/CompanyUsersModel';
import classNames from 'classnames';
import { invert } from 'lodash';
import React from 'react';
import PrimarySelect, { DropdownOption } from '../PrimarySelect/PrimarySelect';
import { RequiredPlanBadge } from '../ProBadge';
import './UserRoleSelector.pcss';

type OuterProps = {
  className?: string;
  onUpdate: (value: string) => void;
  value: string;
  placeholder?: string;
  showTeamBagde?: boolean;
  hideCompanyRoles?: boolean;
};

type Props = OuterProps;

const rolesArr = [
  'Editor',
  'Company Editor',
  'Live Chat Agent',
  'Company Admin',
];

const rolesWithBadgesMap: { [key: string]: boolean } = {
  Admin: true,
  Collaborator: true,
  'Company Admin': true,
  'Company Editor': true,
};

const customOptionRenderer = (option: DropdownOption) => {
  return (
    <div>
      <span>{option.name}</span>
      {option.showTeamBagde && (
        <RequiredPlanBadge
          billingType={PageBillingType.TeamLabel}
          className="user-role-selector__badge"
        />
      )}
    </div>
  );
};

export const UserRoleSelector = ({
  className,
  value,
  onUpdate,
  placeholder,
  showTeamBagde,
  hideCompanyRoles,
}: Props) => {
  const rolesObjArr = rolesArr
    .filter(r => (hideCompanyRoles ? !rolesWithBadgesMap[r] : true))
    .map((r, i) => ({
      id: i,
      name: r,
      showTeamBagde: rolesWithBadgesMap[r] && showTeamBagde,
    }));
  const NewToOLdRolesMap = invert(OldToNewRolesMap);
  const displayValue = NewToOLdRolesMap[value]
    ? NewToOLdRolesMap[value]
    : value;
  return (
    <div className={classNames('user-role-selector', className)}>
      <div className="user-role-selector__selector-container">
        <PrimarySelect
          className="user-role-selector__selector"
          placeholder={placeholder}
          onChange={({ id }) => {
            const newItem = rolesObjArr.find(r => r.id === id);
            if (newItem) {
              onUpdate(OldToNewRolesMap[newItem.name]);
            }
          }}
          value={rolesObjArr.find(r => r.name === displayValue)}
          options={rolesObjArr}
          customOptionRenderer={customOptionRenderer}
          customDropdownStyles={{ zIndex: '99999999' }}
        />
      </div>
    </div>
  );
};
